/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/divider/custom-elements';

import { defineCustomElement as defineOsdsDivider } from '@ovhcloud/ods-stencil/components/divider/custom-elements/osds-divider.js';

export const OsdsDivider = /*@__PURE__*/createReactComponent<JSX.OsdsDivider, HTMLOsdsDividerElement>('osds-divider', undefined, undefined, defineOsdsDivider);
